<template>
  <div class="flex-1 flex-col w-full">
    <global-wrapper
      :loading="$apollo.queries.notifikasi.loading"
      :loadingType="'CardShow'"
    >
      <vx-card v-if="!$apollo.queries.notifikasi.loading">
        <template slot="no-body">
          <global-header :buttonBack="true" :actions="false">
            <template
              slot="actions-custom"
              v-if="!$apollo.queries.notifikasi.loading"
            >
            </template>
          </global-header>
          <div class="w-full flex flex-col p-5 pt-0">
            <div class="w-full flex flex-col">
              <div class="font-bold">Penerima :</div>
              <div>{{ notifikasi.pengguna.nama }}</div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full flex flex-col">
              <div class="font-bold">Waktu Notifikasi :</div>
              <div>{{ notifikasi.created_at | indonesian_date_time }}</div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full flex flex-col">
              <div class="font-bold">Judul :</div>
              <div>{{ notifikasi.judul }}</div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full flex flex-col">
              <div class="font-bold">Konten :</div>
              <div>{{ notifikasi.konten }}</div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full flex flex-col">
              <div class="font-bold">Status :</div> 
              <div>
                <vs-chip class="md-2" color="primary">
                  <vs-avatar
                    icon-pack="feather"
                    icon="icon-tag"
                    :color="notifikasi.is_read ? 'default' : 'primary'"
                  />
                  {{ notifikasi.is_read ? 'Sudah Dibaca' : 'Belum Dibaca' }}
                </vs-chip>
              </div>
            </div>
            <vs-divider></vs-divider>
          </div>
        </template>
      </vx-card>
    </global-wrapper>
  </div>
</template>

<script>
import { GET_DETAIL } from "@/query/notifikasi";

export default {
  data() {
    return {
      notifikasi: {}
    };
  },
  apollo: {
    notifikasi: {
      query: GET_DETAIL,
      update: data => data.notifikasiByUuid,
      variables() {
        return {
          id: this.$route.params.uuid
        };
      }
    },
  },
  created() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Detail Notifikasi");
  }
};
</script>
